<template>
  <div>
      <div class="form-group">
        <label class="col-sm-2 control-label">品牌</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="品牌名称" v-model="brand.text" @input="onPhoneInput">
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: ['brand'],
  methods: {
    onPhoneInput() {
      this.$emit('onPhoneInput')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/Brand.vue